import {
  AGENT_GHOST,
  AGENT_PRIMARY,
  AGENT_SECONDARY,
  DESTRUCTIVE,
  GHOST,
  LINK,
  NEGATIVE,
  PRIMARY,
  PROMOTIONAL,
  SECONDARY,
  TERTIARY,
} from '../../../../utils/spds/constants/buttons';
import {
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import AgentGhostButton from './agent/ghost.gjs';
import AgentPrimaryButton from './agent/primary.gjs';
import AgentSecondaryButton from './agent/secondary.gjs';
import DestructiveButton from './destructive.gjs';
import GhostButton from './ghost.gjs';
import LinkButton from './link.gjs';
import NegativeButton from './negative.gjs';
import PrimaryButton from './primary.gjs';
import PromotionalButton from './promotional.gjs';
import SecondaryButton from './secondary.gjs';
import Super from '../../core/base.gjs';
import TertiaryButton from './tertiary.gjs';

const BUTTON_COMPONENTS = {
  [AGENT_GHOST]: AgentGhostButton,
  [AGENT_PRIMARY]: AgentPrimaryButton,
  [AGENT_SECONDARY]: AgentSecondaryButton,
  [DESTRUCTIVE]: DestructiveButton,
  [GHOST]: GhostButton,
  [LINK]: LinkButton,
  [NEGATIVE]: NegativeButton,
  [PRIMARY]: PrimaryButton,
  [PROMOTIONAL]: PromotionalButton,
  [SECONDARY]: SecondaryButton,
  [TERTIARY]: TertiaryButton,
};

const METADATA = Metadata.define({
  description:
    'Button that can be set to any simple SPDS button type through the `@buttonType` argument',
  extends: [
    pick(BUTTON_ARGS, ['buttonType']),
    pick(COMPONENT_STATE_ARGS, ['autofocus', 'disabled']),
    pick(CONTAINER_ARGS, ['fitContent', 'fitContentHeight', 'fitContentWidth', 'inline']),
    pick(CONTENT_ARGS, [{ name: 'text', initialValue: 'Button' }]),
  ],
  name: 'Variable Button',
});

export default class SpdsActionButtonVariable extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  get buttonType() {
    return this.argOrDefault('buttonType');
  }

  get button() {
    return BUTTON_COMPONENTS[this.buttonType] ?? PrimaryButton;
  }

  <template>
    <this.button
      @autofocus={{@autofocus}}
      @disabled={{@disabled}}
      @fitContent={{@fitContent}}
      @fitContentHeight={{@fitContentHeight}}
      @fitContentWidth={{@fitContentWidth}}
      @id={{this.id}}
      @inline={{@inline}}
      @size={{@size}}
      @text={{@text}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </this.button>
  </template>
}

export const ACTION_BUTTON_VARIABLE_METADATA = SpdsActionButtonVariable.metadata;
